import { render } from "./FTSSectionField.vue?vue&type=template&id=f3252c12&ts=true"
import script from "./FTSSectionField.vue?vue&type=script&lang=ts"
export * from "./FTSSectionField.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__